






import { Component, Prop, Vue } from 'vue-property-decorator';
import { Location } from 'vue-router';
import English from '@/language/English';
import UvaLogo from '@/assets/images/uva-logo.svg';
import UvaLogoEn from '@/assets/images/uva-logo-en.svg';
import Language from '@/language/Language';

@Component
export default class Logo extends Vue {
    @Prop({ type: Object, required: true })
    private language!: Language;

    private get homepageUrl(): Location {
        return {
            name: 'home',
            params: {
                locale: this.$route.params.locale,
            },
        };
    }

    private get logo(): string {
        const english = new English();

        return this.language.code === english.code ? UvaLogoEn : UvaLogo;
    }
}
